// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useMemo } from 'react';
import { useFeatureFlag } from './useFeatureFlag';
import { useFlagsReady } from './useFlagsReady';
import type { SopSource } from '../services/sopFactoryService';

export interface UseSopSourceResult {
  /** False until LaunchDarkly has answered: don't fetch yet, or the wrong source is read first. */
  ready: boolean;
  /** ADM for the site, or `undefined` for the SOP Factory catalog. Stable per site. */
  source: SopSource | undefined;
}

/**
 * Where a screen should read SOPs from (AB#33803): ADM, scoped to `siteId`, while
 * `adm-sop-catalog-enabled` is on and a site is in scope; otherwise `undefined`,
 * which keeps the SOP Factory catalog.
 */
export function useSopSource(siteId: string | undefined): UseSopSourceResult {
  const ready = useFlagsReady();
  const admOn = useFeatureFlag('admSopCatalogEnabled');
  const source = useMemo(() => (admOn && siteId ? { siteId } : undefined), [admOn, siteId]);
  return { ready, source };
}
